import React from 'react';
import { Navigate  } from 'react-router-dom';
import  LoginService  from './../../../services/auth-service'

const withAuth = (WrappedComponent) => {
  return class extends React.Component {
    render() {
      // Check if the user is authenticated
      const isAuthenticated = LoginService.getAccessToken();
      // If the user is authenticated, render the wrapped component
      if (isAuthenticated) {
        return <WrappedComponent {...this.props} />;
      } else {
        // If the user is not authenticated, redirect to the login page
        return <Navigate  to="/" />;
      }
    }
  };
};

export default withAuth;